import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/b016bc6a-342b-48ca-9005-42ab51925da8";
export const REGISTER_URL = "https://a.ntrk2.com/f62c0f98-1ee4-4b29-9700-84eb494921d9";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://winfastph.kzw2a.com/download?openExternalBrowser=1&id=0cexlzycd79kw7f";

export * from "./codes";
export * from "./context";
